import React from "react";
import PropTypes from "prop-types";
import { Dropdown } from "react-bootstrap";
import { translate } from "react-switch-lang";

function CategoryCard({
  t,
  categoryValue,
  currentCategory,
  open,
  setOpen,
  onCardChange,
}) {
  const toggleItem = (item) => {
    if (item === "all") {
      onCardChange("all");
      return;
    }

    const isSelected = categoryValue.includes(item);
    const updated = isSelected
      ? categoryValue.filter((i) => i !== item)
      : [...categoryValue, item];

    onCardChange(updated);
  };

  const isAllSelected = currentCategory === "all";
  const allLabel = t("regions.all");
  const categories = [
    t("categories.Food"),
    t("categories.Elderly"),
    t("categories.Medical"),
    t("categories.Tangible Goods"),
    t("categories.Street"),
    t("categories.Other Services"),
    t("categories.Ethnic Minorities"),
  ];

  const renderTitle = () => {
    if (isAllSelected || categoryValue.length === 0) {
      return `🏷️ ${t("categories.Placeholder")}`;
    }

    if (categoryValue.length === 1) {
      return `🏷️ ${categoryValue[0]}`;
    }

    return `🏷️ 已選 ${categoryValue.length}`;
  };

  return (
    <Dropdown
      drop="down"
      show={open}
      onToggle={(isOpen) => setOpen(isOpen)}
      className="filter-pill w-100"
    >
      <Dropdown.Toggle
        variant="light"
        className="dropdown-toggle-pill w-100 text-start"
      >
        {renderTitle()}
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item
          as="button"
          className="d-flex align-items-center"
          onClick={() => {
            toggleItem("all");
          }}
        >
          <input
            type="checkbox"
            className="me-2 mr-2"
            readOnly
            checked={isAllSelected}
          />
          {allLabel}
        </Dropdown.Item>
        {categories.map((cat, idx) => (
          <Dropdown.Item
            key={idx}
            as="button"
            className="d-flex align-items-center"
            onClick={() => {
              toggleItem(cat);
            }}
          >
            <input
              type="checkbox"
              className="me-2 mr-2"
              readOnly
              checked={categoryValue.includes(cat)}
            />
            {cat}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
}

CategoryCard.propTypes = {
  t: PropTypes.func.isRequired,
  categoryValue: PropTypes.array.isRequired,
  currentCategory: PropTypes.oneOfType([PropTypes.string, PropTypes.array])
    .isRequired,
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  onCardChange: PropTypes.func.isRequired,
};

const TranslateCategoryCard = translate(CategoryCard);
export default TranslateCategoryCard;
